/** 课程页：与代理、配置都无关（视频随前端打包，进度按管端账号记） */
export const LEARNING_PAGES = ["help-videos", "help-learning", "help-rank", "help-operations", "help-client", "help-design", "help-qa", "help-hello-ludo"];

/**
 * 跟当前代理无关的页面：不管各自在顶栏选了哪个代理，看的都是同一份东西。
 * 代理列表、超管、管端账号、Discord 绑定、调试追踪、GM 白名单（全局调试配置）和课程
 */
export const AGENT_FREE_PAGES = [...LEARNING_PAGES, "agents", "accounts", "discord-bind", "debug-trace", "gm"];

/**
 * 这个人跟我是不是在看同一个画面（鼠标、描格只在同一画面里互相看得见）：
 * - 同一页
 * - 跟代理有关的页还要同代理（AGENT_FREE_PAGES 之外的都算）
 * - 读配置的页（versioned）还要同一个配置版本：版本不同，同一格里的东西就不是一回事
 */
export function sameCollabView(p: { a0: string; page: string; version: number | null }, me: { a0: string; page: string; version: number | null; versioned: boolean }): boolean {
  if (p.page !== me.page) return false;
  if (!AGENT_FREE_PAGES.includes(me.page) && p.a0 !== me.a0) return false;
  return !me.versioned || p.version === me.version;
}
